module.exports = __webpack_public_path__ + "static/slack-art-3-40f24d4b95ea34484e0c4ad35bcd2987.png";